import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExtraFieldInput',
    props: {
        value: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const localValue = computed({
            get() {
                return props.value;
            },
            set(val) {
                emit('input', val);
            }
        });
        return { __sfc: true, emit, props, localValue };
    }
});
